import React, {  useState } from "react";
import Calendar from "react-calendar";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import moment from "moment";

import appointmentService from "../../services/appointmentService";

const AppointmentCustomCreate = (props) => {
  const { startOfMonth, endOfMonth, currentDate, refreshMonth } = props;
  const [modal, setModal] = useState(false);
  const [selectedDates, setSelectedDates] = useState([]);

  const toggle = () => {
    setSelectedDates([]);
    setModal(!modal);
  };
  const addAppointment = (date) => {
    //console.log(date);
    var filtered = selectedDates.filter((el) => {
      return el.date === moment(date).format("MM-DD-YY");
    });
    //console.log(filtered.length);
    if (filtered.length !== 0) {
      return;
    }
    setSelectedDates((selectedDates) => [
      ...selectedDates,
      { date: moment(date).format("MM-DD-YY") },
    ]);
    //setSelectedDates({ ...sd });
    //console.log(selectedDates);
  };
  const removeAppointment = (dateFilter) => {
    //console.log(selectedDates);
    var filtered = selectedDates.filter((el) => {
      return el.date !== dateFilter;
    });
    setSelectedDates(filtered);
    //console.log(filtered);
  };

  const submitDates = () => {
    appointmentService.createCustomAppointments(selectedDates).then(() => {
      refreshMonth();
      toggle();
    });
  };
  return (
    <div>
      <Button
        type="button"
        className="btn btn-info"
        onClick={toggle}
        style={{ marginBottom: "10px", width: "100%" }}
      >
        Create custom appointments
      </Button>
      <Modal isOpen={modal} toggle={toggle} size="md">
        <ModalHeader toggle={toggle}>Add a new appointment</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={8}>
              <h5 style={{ textAlign: "center" }}>Select a date to add</h5>
              <Calendar
                onChange={(date) => addAppointment(date)}
                activeStartDate={
                  new Date(currentDate.year, currentDate.month - 1, 1)
                }
                tileDisabled={({ activeStartDate, date, view }) => {
                  if (date < startOfMonth) {
                    return date;
                  }
                  if (date > endOfMonth) {
                    return date;
                  }
                }}
              />
            </Col>
            <Col md={4} style={{ borderLeft: "1px solid #dee2e6" }}>
              <h5>Selected dates</h5>
              <ListGroup>
                {selectedDates.map((a) => (
                  <ListGroupItem key={a.date}>
                    {a.date}{" "}
                    <sup>
                      {" "}
                      <Button
                        color="link"
                        onClick={() => removeAppointment(a.date)}
                        style={{
                          verticalAlign: "super",
                          padding: "0",
                          margin: "0",
                          color: "red",
                        }}
                      >
                        x
                      </Button>
                    </sup>
                  </ListGroupItem>
                ))}
              </ListGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={submitDates}>
            Add Dates
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AppointmentCustomCreate;
